// @flow
import type { Store as ReduxStore } from "redux";
import { type StateUser, type ActionUser } from "./reducer";

// eslint-disable-next-line import/prefer-default-export
export const isLoggedIn = (store: ReduxStore<StateUser, ActionUser>) =>
  !!(store.user.token && store.user.email);

export const isPasswordExpired = (store: ReduxStore<StateUser, ActionUser>) =>
  store.user.passwordExpired;

export const getUserToken = (store: ReduxStore<StateUser, ActionUser>) => store.user.token;
